export type FilterType = 'checkbox' | 'radio' | 'numeric' | 'layout';

export const SUPPORTED_FILTER_TYPES: readonly FilterType[] = [
	'checkbox',
	'layout',
	'numeric',
];

export interface FiltersInterface {
	title: string;
	items?: FiltersItemInterface[];
	type: FilterType;
	maxValue?: number;
}

export interface FiltersItemInterface {
	name: string;
	value: string;
	frequency: number;
	icon?: string;
}
